/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<f4d79b58ae00bb2453a88d681374c215>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type resourcesFragment$data = {
  readonly helpObjectStore: {
    readonly __typename: "HelpObjectStoreQueryApi";
    readonly " $fragmentSpreads": FragmentRefs<"articlesFragment" | "portalsFragment" | "requestFormsFragment">;
  };
  readonly " $fragmentType": "resourcesFragment";
};
export type resourcesFragment$key = {
  readonly " $data"?: resourcesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"resourcesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "resourcesFragment",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "HelpObjectStoreQueryApi",
        "kind": "LinkedField",
        "name": "helpObjectStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "articlesFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "requestFormsFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "portalsFragment"
          }
        ],
        "storageKey": null
      },
      "action": "THROW",
      "path": "helpObjectStore"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "1c19d7befced4e6f52ed02a206d8bb7f";

export default node;
